import React from 'react'
import { Link } from "react-router-dom"
import { ShoppingCart, Search } from "react-feather"
import clsx from "clsx"
import Card from "./Card"

export default function Category({ title, imgSrc, link }) {
	return (
		<Link to={link}>
			{/* <Card 
				imgSrc={imgSrc} 
				className={clsx(
					"!max-w-48 !max-h-sm sm:(!max-w-64)",
				)}>
				<div className={clsx(
	      	"absolute inset-0 text-white text-center",
	      	"flex justify-center items-center",
	      	"transition duration-500 ease-out",
	      	"group-hover:(bg-black/40)"
      	)}>
	      	<h3 className="text-2xl font-bold tracking-widest uppercase p-4 bg-black/30">{title}</h3>
	      </div>
			</Card> */}

			<Card
			imgSrc={imgSrc}
			className={clsx(
				// "relative overflow-hidden rounded-xl",
				// "max-w-32 sm:max-w-45",
				// "!max-w-62 !max-h-xs",
				// "aspect-square",
				// "group cursor-pointer"

				"relative sm:w-72 w-35 sm:h-100 h-60",
				"!max-w-72",
				// "!max-w-72 !max-h-xs",
				// "rounded-lg m-3 overflow-hidden",
               // "shadow-md hover:shadow-lg transition-all duration-300",
				"rounded-lg m-2",
			)}
			>

		   <img
			src={imgSrc}
			alt={title}
			className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
		   />
		{/* Footer */}
		<div
			className={clsx(
			"absolute bottom-0 left-0 right-0",
			"bg-black/60 backdrop-blur-sm",
			"text-white text-center",
			"py-3"
			)}
		>
			<h3 className="text-xs sm:text-base lg:text-lg font-semibold tracking-wide uppercase">
			{title}
			</h3>
		</div>
		</Card>
		</Link>
	)
}